<div class="Customers">


    <div class="container">
        <div class="ui-g">
            <div class="ui-g-12">
                <div class="card">
                    <div class="ui-g form-group master-data">
                        <div class="ui-g-8">
                            <h1 class="step-title">Edit Customer</h1>
                        </div>
                        <div class="ui-g-4">
                            <button pButton type="button" class="SaveExit" icon="fa fa-angle-left" label="back"></button>
                        </div>
                        <div class="ui-g-12">
                            <p-steps [model]="items"></p-steps>
                        </div>
                    </div>
                </div>


                <div class="card">
                    <div class="ui-g form-group master-data">


                        <div class="ui-g-2">
                            <label>Customer Code</label>
                            <input type="text" placeholder="Es. 12" pInputText>
                        </div>
                        <div class="ui-g-10">

                        </div>

                        <div class="ui-g-6"><label>Name</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-6"><label>Surname</label>
                            <input type="text" pInputText></div>


                        <div class="ui-g-12"><label>Fiscal Code</label>
                            <input type="text" pInputText></div>

                        <div class="ui-g-12">
                            <hr style="border-top:0px;border-color:#dde3e6">
                        </div>
                    </div>


                    <div class="ui-g form-group master-data">
                        <div class="ui-g-12"><label>Address</label></div>


                        <div class="ui-g-10">
                            <label>Venue</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-2"><label>Number</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-2"><label>Province</label>
                            <p-dropdown [options]="cities" [(ngModel)]="selectedCity"></p-dropdown>
                        </div>
                        <div class="ui-g-10"><label>City</label>
                            <p-dropdown [options]="cities" [(ngModel)]="selectedCity"></p-dropdown>
                        </div>
                        <div class="ui-g-2"><label>Zip Code</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-10"><label>Country</label>
                            <p-dropdown [options]="cities" [(ngModel)]="selectedCity"></p-dropdown>
                        </div>
                        <div class="ui-g-12">
                            <hr style="border-top:0px;border-color:#dde3e6">
                        </div>
                    </div>


                    <div class="ui-g form-group master-data">


                        <div class="ui-g-6">
                            <label>Telephone</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-6"><label>Mobile</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-6"><label>Email 1</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-6"><label>Email 2</label>
                            <input type="text" pInputText></div>
                    </div>

                    <div class="ui-g form-group master-data">

                        <div class="ui-g-12"><label>Authorizations</label></div>


                        <div class="ui-g-12">
                            <label>Send Name and surname to the register</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>

                        <div class="ui-g-12">
                            <label>Authorization general comunications</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>

                        <div class="ui-g-12">
                            <label>Market Research</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>

                        <div class="ui-g-12">
                            <label>Authorization Privacy</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>

                        <div class="ui-g-12">
                            <label>Profiling</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>

                        <div class="ui-g-12">
                            <label>Marketing Activities</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>

                        <div class="ui-g-12">
                            <label>Authorization purchase comunications</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>

                        <div class="ui-g-12">
                            <label>Push Notification code</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>


                        <div class="ui-g-12 center">
                            <button type="button" class="SaveExit" label="Save Changes" pButton></button>
                        </div>

                    </div>
                </div>

                <div class="card">
                    <div class="ui-g form-group master-data">

                        <div class="ui-g-6">
                            <label>Married</label>
                            <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
                        </div>
                        <div class="ui-g-6">
                            <button pButton type="button" class="SaveExit more" icon="fa fa-plus-circle"
                                    label="Add custom field"></button>
                        </div>

                        <div class="ui-g-12">
                            <label>Family Members</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-12"><label>Relative Members</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-12"><label>Children number</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-8"><label>Birthday City</label>
                            <input type="text" pInputText></div>
                        <div class="ui-g-4"><label>Birthday date</label>
                            <p-calendar class="over" [(ngModel)]="date3" [showIcon]="true"></p-calendar>
                        </div>
                        <div class="ui-g-12"><label>Spouse's birthday date</label>
                            <p-calendar class="over" [(ngModel)]="date3" [showIcon]="true"></p-calendar>
                        </div>
                        <div class="ui-g-12"><label>First child's birthday date</label>
                            <p-calendar class="over" [(ngModel)]="date3" [showIcon]="true"></p-calendar>
                        </div>
                        <div class="ui-g-12"><label>Sex</label></div>
                        <div class="ui-g-6">
                            <p-radioButton name="rg" value="Male" label="Male" [(ngModel)]="radioValue"></p-radioButton>
                        </div>
                        <div class="ui-g-6"><label></label>
                            <p-radioButton name="rg" value="Female" label="Female"
                                           [(ngModel)]="radioValue"></p-radioButton>
                        </div>
                        <div class="ui-g-12"><label>Educational Qualification</label>
                            <input pinputtext="" type="text"
                                   class="ui-inputtext ui-corner-all ui-state-default ui-widget"></div>
                        <div class="ui-g-12"><label>Occupation</label>
                            <input pinputtext="" type="text"
                                   class="ui-inputtext ui-corner-all ui-state-default ui-widget"></div>

                        <div class="ui-g-12 center">
                            <button pButton type="button" class="SaveExit" label="Save Changes"></button>


                        </div>

                    </div>


                </div>

                <div class="card">
                    <div class="ui-g form-group master-data">


                        <div class="ui-g-12">
                            <div class="ui-g-6">
                                <h1>Expense history</h1>
                            </div>
                            <div class="ui-g-6">
                                <h1>Redemption rate</h1>
                            </div>
                        </div>


                        <div class="ui-g-6">
                            <div class="expense">
                                <label>Group</label>
                                <div class="list">1 -Superfedeli</div>
                            </div>

                            <div class="expense">
                                <label>Last transaction</label>
                                <div class="list">17/02/2017</div>
                            </div>

                            <div class="expense">
                                <label>Store</label>
                                <div class="list">Mi-Piccinini</div>
                            </div>

                            <div class="expense">
                                <label>Favourite store</label>
                                <div class="list">Mi-Piccinini</div>
                            </div>

                            <div class="expense">
                                <label>Expense</label>
                                <div class="list">5,6754.34 €</div>
                            </div>

                            <div class="expense">
                                <label>Frequency</label>
                                <div class="list">234</div>
                            </div>

                            <div class="expense">
                                <label>Newness</label>
                                <div class="list">0</div>
                            </div>

                            <div class="expense">
                                <label>Avg. expense per transaction</label>
                                <div class="list">22.55 €</div>
                            </div>

                        </div>

                        <div class="ui-g-6">
                            <p-chart type="doughnut" [data]="pieData"></p-chart>
                            <label>Cards history</label>
                            <div class="list-campaign">
                                <div class="ui-g-12 list">
                                    <div class="ui-g-8">
                                        <div class="user-name">1 - Superfedeli</div>
                                    </div>
                                    <div class="ui-g-4">
                                        <div class="number">
                                            31/12/2017
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>

                        <div class="ui-g-12">
                            <hr style="border-top:0px;border-color:#dde3e6">
                        </div>

                        <div class="ui-g-12">
                            <p-dataTable [value]="cars1" selectionMode="single" [(selection)]="selectedCar"
                                         [paginator]="false" [rows]="10" [responsive]="true">
                                <p-header>Coupon</p-header>
                                <p-column field="vin" header="Card Code" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="year" header="Store Origin Code" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="brand" header="Cust. Code" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="color" header="Cust. Name" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="brand" header="SelfScanning" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                            </p-dataTable>
                        </div>

                        <div class="ui-g-12">
                            <hr style="border-top:0px;border-color:#dde3e6">
                        </div>

                        <div class="ui-g-12">
                            <p-dataTable [value]="cars1" selectionMode="single" [(selection)]="selectedCar"
                                         [paginator]="false" [rows]="10" [responsive]="true">
                                <p-header>Purchases history</p-header>
                                <p-column field="vin" header="Card Code" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="year" header="Store Origin Code" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="brand" header="Cust. Code" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="color" header="Cust. Name" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="brand" header="SelfScanning" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                            </p-dataTable>
                        </div>

                    </div>


                    <div class="ui-g form-group master-data">
                        <div class="ui-g-12">
                            <div class="ui-g-6">
                                <label>Expenses</label>
                                <p-chart type="line" [data]="lineData"></p-chart>


                            </div>
                            <div class="ui-g-6">
                                <label>Number of transactions</label>
                                <p-chart type="line" [data]="lineData"></p-chart>

                            </div>
                        </div>
                    </div>


                </div>

                <div class="card">
                    <div class="ui-g form-group master-data">
                        <div class="ui-g-12">


                            <div class="search">
                                <label>Search</label>
                                <div class="ui-g-8">
                                    <input placeholder="Type a card code or a store origin code" type="text">
                                </div>
                                <div class="ui-g-4">
                                    <button pButton type="button" class="SaveExit" label="Find!"></button>
                                </div>
                            </div>


                        </div>

                        <div class="ui-g-12 card"><div class="PreCard">12 Cards</div></div>

                        <div class="ui-g-12">
                            <p-dataTable [value]="cars" selectionMode="single" [(selection)]="selectedCar" [paginator]="false" [rows]="10" [responsive]="true">
                                <p-header>List of Cars</p-header>
                                <p-column field="vin" header="Card Code" [filter]="true" filterPlaceholder="Search" [sortable]="true"></p-column>
                                <p-column field="year" header="Store Origin Code" [sortable]="true"></p-column>
                                <p-column field="brand" header="Cust. Code" [sortable]="true"></p-column>
                                <p-column field="color" header="Cust. Name" [sortable]="true"></p-column>
                                <p-column field="brand" header="SelfScanning" [sortable]="true"></p-column>
                                <p-column field="color" header="Blacklist" [sortable]="true"></p-column>
                            </p-dataTable>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-preview.html